import { render, staticRenderFns } from "./IssuesDetail.vue?vue&type=template&id=766b83b2&"
import script from "./IssuesDetail.vue?vue&type=script&lang=js&"
export * from "./IssuesDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports